export default __webpack_public_path__ + "static/media/639a27ee0f67b60083c57a92_martech_midnight_blue_svg (2).52b18928.svg";